import { apiGet } from "../../services/genesisApi/httpsMethods";
import type { PartialDeal } from "../../types/deal";

/** Fetch sponsor/secondary-sponsor borrowers linked to this deal. */
export async function withDealBorrowers(deal: PartialDeal): Promise<PartialDeal> {
  const next: PartialDeal = { ...deal };

  if (typeof deal.sponsor === "object" && deal.sponsor?.id) {
    const response = await apiGet(
      `sponsor/${deal.sponsor.id}/borrowers?deal_id=${deal.id}`,
    );
    if (response.success && response.data) {
      next.borrowers = response.data;
    }
  }

  if (
    typeof deal.secondary_sponsor === "object" &&
    deal.secondary_sponsor?.id
  ) {
    const response = await apiGet(
      `sponsor/${deal.secondary_sponsor.id}/borrowers?deal_id=${deal.id}`,
    );
    if (response.success && response.data) {
      next.secondary_borrowers = response.data;
    }
  }

  return next;
}

export async function fetchDealAssets(dealId: number) {
  try {
    const response = await apiGet(`assets?dealId=${dealId}`);
    if (response.success && Array.isArray(response.data)) {
      return response.data;
    }
  } catch {
    // Tables can still load assets themselves
  }
  return [];
}

export async function fetchDealTenants(dealId: number) {
  try {
    const response = await apiGet(`tenants?dealId=${dealId}`);
    if (response.success && Array.isArray(response.data)) {
      return response.data;
    }
  } catch {
    // Tables can still load tenants themselves
  }
  return [];
}

/** Contacts whose links include this deal. */
export function contactsLinkedToDeal(allContacts: any[], dealId: number) {
  return (allContacts || []).filter(
    (contact: any) =>
      Array.isArray(contact?.links) &&
      contact.links.some((link: any) => link?.deal_id === dealId),
  );
}

export async function fetchContactsLinkedToDeal(dealId: number) {
  try {
    const response = await apiGet("contacts");
    if (response.success && Array.isArray(response.data)) {
      return contactsLinkedToDeal(response.data, dealId);
    }
  } catch {
    // Contacts table can still load from the reference list
  }
  return [];
}
